/** @jsxImportSource @emotion/react */
import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { CardBody } from "../../components/page-skeleton/CardBody";
import { css } from "@emotion/react";
import { SpinnerBlock } from "../common/Spinner";
import { useListPackingItems } from "./service/packing-items-api";
import { EmptyState } from "../../components/EmptyState";
import { MutatePackingItemSelector } from "./components/MutatePackingItemSelector";
import { useGetKitchenCategories } from "../kitchen-categories/service/kitchen-categories-api";
import { PackingItemsTable } from "./components/PackingItemsTable";
import { useHandleFetchError } from "../../error-handler";

const cardBodyAdditionalStyling = css`
  padding-bottom: 24px;
`;

export const PackingItemsList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data, isLoading, error } = useListPackingItems(organizationKeyName);
  const {
    data: kitchenCategories,
    isLoading: isLoadingKitchenCategories,
    error: listKitchenCategoriesError,
  } = useGetKitchenCategories(organizationKeyName);

  useHandleFetchError(error);
  useHandleFetchError(listKitchenCategoriesError);

  if (isLoading || isLoadingKitchenCategories || !kitchenCategories) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="Packing items"
          subtitle="Manage all of your packing items"
        >
          <MutatePackingItemSelector />
        </PageHeader>
        {data?.length === 0 || !data ? (
          <CardBody additionalStyles={cardBodyAdditionalStyling}>
            <EmptyState
              title="No packing items created yet"
              subtitle="Create your first packing item by pressing on create packing item in top right corner"
            />
          </CardBody>
        ) : (
          <PackingItemsTable
            packingItems={data}
            kitchenCategories={kitchenCategories}
          />
        )}
      </CardContainer>
    </PageWrapper>
  );
};
